// Table structure verification test
import { getSupabaseUrl, getSupabaseAnonKey } from '../config/supabase';

export const checkTableStructure = async (tableName) => {
  console.log(`🔍 Checking structure of table: ${tableName}`);
  
  try {
    const supabaseUrl = getSupabaseUrl();
    const supabaseKey = getSupabaseAnonKey();

    // Try to get table structure by making a request with select=*
    const response = await fetch(`${supabaseUrl}/rest/v1/${tableName}?select=*&limit=1`, {
      headers: {
        'apikey': supabaseKey,
        'Authorization': `Bearer ${supabaseKey}`
      }
    });

    if (response.ok) {
      const data = await response.json();
      console.log(`✅ Table '${tableName}' structure check successful`);
      console.log(`📊 Sample data (first row):`, data[0] || 'No data in table');
      
      if (data.length > 0) {
        const columns = Object.keys(data[0]);
        console.log(`📋 Available columns: ${columns.join(', ')}`);
        return { success: true, columns, sampleData: data[0] };
      } else {
        console.log(`📋 Table is empty, cannot determine columns from data`);
        return { success: true, columns: [], sampleData: null };
      }
    } else {
      const errorText = await response.text();
      console.log(`❌ Failed to check table structure: ${response.status} - ${errorText}`);
      return { success: false, error: `${response.status} - ${errorText}` };
    }
  } catch (error) {
    console.log(`❌ Error checking table structure:`, error.message);
    return { success: false, error: error.message };
  }
};

export const runTableStructureTest = async () => {
  console.log('🔍 Starting table structure verification...');
  
  const results = {
    tables: {},
    errors: []
  };

  // Focus on the problematic table first
  const problematicTables = ['tmdb_cache', 'movie_collection'];
  
  for (const tableName of problematicTables) {
    try {
      const result = await checkTableStructure(tableName);
      results.tables[tableName] = result;
    } catch (error) {
      console.error(`❌ Failed to check ${tableName}:`, error);
      results.errors.push(`${tableName}: ${error.message}`);
    }
  }

  // Summary
  console.log('\n📊 TABLE STRUCTURE TEST SUMMARY:');
  console.log('=================================');
  
  Object.entries(results.tables).forEach(([tableName, result]) => {
    if (result.success) {
      console.log(`✅ ${tableName}: ${result.columns.length} columns found`);
      if (result.columns.length > 0) {
        console.log(`   Columns: ${result.columns.join(', ')}`);
      }
    } else {
      console.log(`❌ ${tableName}: ${result.error}`);
    }
  });

  if (results.errors.length > 0) {
    console.log('\n❌ ERRORS:');
    results.errors.forEach(error => console.log(`  - ${error}`));
  }

  return results;
};













